/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Build_Guided_NoteInputs */

const en_mk_build_guided_note = /** @type {(inputs: Mk_Build_Guided_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A separate service from your subscription. Choose the support and review its cost before booking.`)
};

const id_mk_build_guided_note = /** @type {(inputs: Mk_Build_Guided_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layanan terpisah dari langganan. Pilih jenis bantuan dan lihat biayanya sebelum memesan.`)
};

/**
* | output |
* | --- |
* | "A separate service from your subscription. Choose the support and review its cost before booking." |
*
* @param {Mk_Build_Guided_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_build_guided_note = /** @type {((inputs?: Mk_Build_Guided_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Build_Guided_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_build_guided_note(inputs)
	return en_mk_build_guided_note(inputs)
});